import React from 'react';
import { Table, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import type { StationRow } from '../types/routeFormTypes';

interface RouteWaypointSectionProps {
    totalHours: string;
    totalMiles: string;
    columns: TableColumnsType<StationRow>;
    tableData: StationRow[];
    waypointCount: number;
    maxWaypointCount: number;
    onAddWaypoint: () => void;
}

const RouteWaypointSection: React.FC<RouteWaypointSectionProps> = ({
    totalHours,
    totalMiles,
    columns,
    tableData,
    waypointCount,
    maxWaypointCount,
    onAddWaypoint,
}) => {
    const { t } = useTranslation();

    return (
        <>
            {/* Summary Section */}
            <div className="bg-white mb-4 p-3 border border-gray-200">
                <div className="flex gap-4">
                    <span>{String(t('tms.route.drawer.estimatedTotalTime'))} </span>
                    <span className="font-bold">{totalHours} {String(t('tms.route.drawer.hours'))}</span>
                    <span>{String(t('tms.route.drawer.estimatedTotalDistance'))} </span>
                    <span className="font-bold">{totalMiles} {String(t('tms.route.drawer.miles'))}</span>
                </div>
            </div>

            {/* Table Section */}
            <div className="mb-4">
                <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    size="small"
                    className="mb-4"
                />
            </div>

            {/* Footer Button */}
            <div className="flex justify-start mb-4">
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onAddWaypoint}
                    disabled={waypointCount >= maxWaypointCount}
                    className="w-full"
                >
                    {String(t('tms.route.drawer.addWaypoint'))}
                </Button>
            </div>
        </>
    );
};

export default RouteWaypointSection;
